import { createRouter, createWebHistory } from 'vue-router'
import BasicLayout from './core/base-layout.vue'
import { afterRouterGuard } from './core/guard'
import enterpriseRoutes from './modules/enterpise'

export function routerInit(base: string) {
  const instance = createRouter({
    history: createWebHistory(base),
    routes: [
      {
        path: '/',
        component: BasicLayout,
        children: enterpriseRoutes
      },
      {
        path: '/403',
        component: () => import('@/views/error/403-page.vue'),
        meta: { title: '403' }
      },
      {
        path: '/:pathMatch(.*)*',
        component: () => import('@/views/error/404-page.vue'),
        meta: { title: '404' }
      }
    ],
    scrollBehavior(to, _, savedPosition: { left: number; top: number } | null) {
      if (savedPosition) return savedPosition
      if (to.hash) {
        return { el: to.hash, behavior: 'smooth' }
      }
      return { left: 0, top: 0 }
    }
  })

  instance?.beforeEach((to) => {
    const title = to.meta.title as string | undefined
    if (title) {
      document.title = `${title} - ReMaps`
    }
    return true
  })

  instance?.afterEach(async (to, from, failure) => {
    await afterRouterGuard(to, from, failure)
  })

  return instance
}
